import { useIsFetching, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getDotations } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useDotations() {
  const isLoginFetching = useIsFetching({ queryKey: ["login"] });
  return useQuery({
    queryKey: ["dotations"],
    queryFn: async () => {
      const { response, data, error } = await getDotations();

      if (response.status === 403) {
        useSessionExpiredStore().setSessionExpired(true);
      }

      if (error) {
        throw error;
      }

      return data;
    },
    enabled: computed(() => isLoginFetching.value === 0),
  });
}
